export default __webpack_public_path__ + "static/media/Gilroy.86bc2a5a.woff";